export function ModuleTitleTRAINING() {
  return (
    <div className="flex items-baseline gap-3">
      <h2
        className="patria-module-title text-lg sm:text-xl"
        data-testid="training-module-title"
      >
        TRAINING
      </h2>
      <span className="text-xs uppercase tracking-widest text-charcoal-muted">
        Onboarding &amp; Formation Library
      </span>
    </div>
  );
}
